import { render, staticRenderFns } from "./TasksButton.vue?vue&type=template&id=64ff04a9&"
import script from "./TasksButton.vue?vue&type=script&lang=js&"
export * from "./TasksButton.vue?vue&type=script&lang=js&"
import style0 from "./TasksButton.vue?vue&type=style&index=0&id=64ff04a9&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports